import { useQuery } from "@tanstack/react-query";
import { RemindersKeys } from "web_myplann/Api/Reminders/RemindersKeys";
import { selectReminders } from "web_myplann/Api/Reminders/selectReminders";
import { getClientIdentificationDocumentsIdRemindersV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useIdentificationDocumentRemindersListQuery = (
	documentId: number,
) =>
	useQuery({
		queryKey: RemindersKeys.identificationDocumentList(documentId),
		queryFn: processResponseQuery(() =>
			getClientIdentificationDocumentsIdRemindersV2(documentId),
		),
		select: selectReminders,
	});
